import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";
import CommaSeparatorHelper from "../helpers/CommaSeparatorCountHelper";

class ClaimsStore {
  @observable claims = [];
  @observable drug_count = 0;
  @observable single_drug = {};
  @observable therapeuticByCost = []
  @observable url = "/api/v1/dataactions/claims";
  @observable filterValue = "";
  @observable brandings = [{
    'Specialty': 0,
    'generic': 0,
    'branded': 0
  }];
  @observable actureOrMaintenance = [
    {
      'acute': 0,
      'maintenance': 0,

    }
  ];
  @observable claimsCount = [{
    "0-20": "0",
    "20-100": "0",
    "100-750": "0",
    "750+": "0"
  }];
  @observable claimsSpending = [{
    "0-20": "0",
    "20-100": "0",
    "100-750": "0",
    "750+": "0"
  }];

  @computed get tiles() {
    return parseInt(this.drug_count / 100) > 0 ? parseInt(this.drug_count / 100) + 1 : 0;
  }


  @action sortbydesc(filter) {
    this.filterValue = filter;
    if (this.claims.length > 0) {

      if (filter == "label_name") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.label_name > b.label_name) return -1;
          if (a.label_name < b.label_name) return 1;
          return 0
        })
      }

      if (filter == "total_cost") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.COST) > parseInt(b.COST)) return -1;
          if (parseInt(a.COST) < parseInt(b.COST)) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return 1;
          return 0
        })
      }

      if (filter == "claims_count") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return 1;
          return 0
        })
      }

      if (filter == "awp_price") {
        this.claims = this.claims.sort(function (a, b) {
          if (((a.awp_price - a.COST) / a.awp_price) * 100 > ((b.awp_price - b.COST) / b.awp_price) * 100) return -1;
          if (((a.awp_price - a.COST) / a.awp_price) * 100 < ((b.awp_price - b.COST) / b.awp_price) * 100) return 1;
          return 0
        })
      }

      if (filter == "unique_par") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.unique_par > b.unique_par) return -1;
          if (a.unique_par < b.unique_par) return 1;
          return 0
        })
      }

      if (filter == "drug_type") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.drug_type > b.drug_type) return -1;
          if (a.drug_type < b.drug_type) return 1;
          return 0
        })
      }

      if (filter == "therapeutic_name") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.therapeutic_name > b.therapeutic_name) return -1;
          if (a.therapeutic_name < b.therapeutic_name) return 1;
          return 0
        })
      }

    }
  }

  @action sortbyasc(filter) {
    this.filterValue = filter;
    if (this.claims.length > 0) {

      if (filter == "label_name") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.label_name < b.label_name) return -1;
          if (a.label_name > b.label_name) return 1;
          return 0
        })
      }

      if (filter == "total_cost") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.COST) < parseInt(b.COST)) return -1;
          if (parseInt(a.COST) > parseInt(b.COST)) return 1;
          return 0
        })
      }

      if (filter == "plan_pay") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.plan_pay) < parseInt(b.plan_pay)) return -1;
          if (parseInt(a.plan_pay) > parseInt(b.plan_pay)) return 1;
          return 0
        })
      }

      if (filter == "co_pay") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.co_pay) < parseInt(b.co_pay)) return -1;
          if (parseInt(a.co_pay) > parseInt(b.co_pay)) return 1;
          return 0
        })
      }

      if (filter == "claims_count") {
        this.claims = this.claims.sort(function (a, b) {
          if (parseInt(a.claims_count) < parseInt(b.claims_count)) return -1;
          if (parseInt(a.claims_count) > parseInt(b.claims_count)) return 1;
          return 0
        })
      }

      if (filter == "awp_price") {
        this.claims = this.claims.sort(function (a, b) {
          if (((a.awp_price - a.COST) / a.awp_price) * 100 < ((b.awp_price - b.COST) / b.awp_price) * 100) return -1;
          if (((a.awp_price - a.COST) / a.awp_price) * 100 > ((b.awp_price - b.COST) / b.awp_price) * 100) return 1;
          return 0
        })
      }

      if (filter == "unique_par") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.unique_par < b.unique_par) return -1;
          if (a.unique_par > b.unique_par) return 1;
          return 0
        })
      }

      if (filter == "drug_type") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.drug_type < b.drug_type) return -1;
          if (a.drug_type > b.drug_type) return 1;
          return 0
        })
      }

      if (filter == "therapeutic_name") {
        this.claims = this.claims.sort(function (a, b) {
          if (a.therapeutic_name < b.therapeutic_name) return -1;
          if (a.therapeutic_name > b.therapeutic_name) return 1;
          return 0
        })
      }

    }
  }
  @action getHighClaimSpend = async (data) => {
    try {
      let response = await post(
        `${this.url}/getHighClaimSpend`,
        data
      );

      this.claims = CommaSeparatorHelper(response.data, "unique_par", true)
    } catch (err) {
      console.log(err);
    }

  }
  @action getDrugCount = async (data) => {
    try {
      let response = await post(
        `${this.url}/getDrugCount`,
        data
      );

      this.drug_count = response.data[0].drug_count;
    } catch (err) {
      console.log(err);
    }
  }

  @action getSingleDrug = async (data) => {
    try {
      this.single_drug={}
      let response = await post(
        `${this.url}/getSingleDrug`,
        data
      );

      this.single_drug = response.data[0];
    } catch (err) {
      console.log(err);
    }

  }
  @action getBrandings = async (data) => {
    try {
      let response = await post(
        `${this.url}/getBrandings`,
        data
      );

      this.brandings = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getBrandingsByCost = async (data) => {
    try {
      let response = await post(
        `${this.url}/getBrandingsByCost`,
        data
      );

      this.brandings = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action getMaintenanceOrAcute = async (data) => {
    try {
      let response = await post(
        `${this.url}/getMaintenanceOrAcute`,
        data
      );

      this.actureOrMaintenance = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getMaintenanceOrAcuteByCost = async (data) => {
    try {
      let response = await post(
        `${this.url}/getMaintenanceOrAcuteByCost`,
        data
      );

      this.actureOrMaintenance = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action getClaimsCount = async (data) => {
    try {
      let response = await post(
        `${this.url}/getClaimsCount`,
        data
      );

      this.claimsCount = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action getClaimsSpendings = async (data) => {
    try {
      let response = await post(
        `${this.url}/getClaimsSpendings`,
        data
      );

      this.claimsSpending = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getTherapeuticByCost = async (data) => {
    try {
      let response = await post(
        `${this.url}/getTherapeuticByCost`,
        data
      );

      this.therapeuticByCost = response.data;
    } catch (err) {
      console.log(err);
    }
  }








}

export default ClaimsStore;
